import React, { useState } from "react";

const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleConfirm = (e) => {
    setIsButtonDisabled(true); // Disable buttons after clicking
    onConfirm(e); // Execute onConfirm action
  };

  const handleCancel = (e) => {
    setIsButtonDisabled(true); // Disable buttons after clicking
    if (onCancel) onCancel(e); // Execute onCancel action if provided
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/80 z-50">
      <div className="flex flex-col items-center">
        <div className="bg-gray-950/50 px-4 py-3 border border-pink-300/30 rounded-lg flex flex-col items-center">
          <h2 className="text-white text-lg text-center font-semibold mb-4">
            {message}
          </h2>
          <div className={`flex ${onCancel ? "gap-4" : ""}`}>
            <button
              onClick={handleConfirm}
              className={`px-6 py-2 text-white rounded-lg transition-all duration-200 ease-in-out 
                ${isButtonDisabled 
                  ? "bg-blue-400 cursor-not-allowed" // Disabled style
                  : "bg-blue-500/50 hover:bg-blue-950/90"
                }`}
              disabled={isButtonDisabled}
            >
              OK
            </button>
            {onCancel && (
              <button
                onClick={handleCancel}
                className={`px-6 py-2 text-white rounded-lg transition-all duration-200 ease-in-out 
                  ${isButtonDisabled 
                    ? "bg-red-400 cursor-not-allowed" // Disabled style
                    : "bg-red-500/50 hover:bg-red-950/90"
                  }`}
                disabled={isButtonDisabled}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
